import { takeEvery, call, all, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';

import { fetchEntityIfNotLoading } from 'helpers/core';

import { selectActiveVenueId } from 'selectors/general';
import { userInfo, userInsights, userInsightsGraph } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED } from 'features/App';

export function* doFetchUserInsights(client, action) {
  const { venueId } = action;
  yield all([
    call(fetchEntityIfNeeded, userInsights, [client, venueId]),
    call(fetchEntityIfNeeded, userInsightsGraph, [client, venueId]),
  ]);
}

export function* handleUserInsightsRouteEnter(client) {
  const user = yield call(fetchEntityIfNotLoading, userInfo, [client]);
  const venueId = yield select(selectActiveVenueId);
  yield call(doFetchUserInsights, client, { venueId, permissions: user.permissions });
}

export function* watchUserInsightsModule(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, doFetchUserInsights, client);
}
